export default "__VITE_ASSET__pG6xSKz0__"